module.exports = __webpack_public_path__ + "static/media/c-logo.aefba360.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/c-logo.png
// module id = 488
// module chunks = 0